import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import memorygame from '../../assets/images/memory.png'
import UserSelector from '../../components/UserSelector'
import { useGetGameReportsQuery, useSaveGameReportMutation } from '../../redux/api/activityApi'
import anaconda from './images/anaconda.png'
import bee from './images/bee.png'
import chameleon from './images/chameleon.png'
import cockatoo from './images/cockatoo.png'
import crocodile from './images/crocodile.png'
import gorilla from './images/gorilla.png'
import macaw from './images/macaw.png'
import monkey from './images/monkey.png'
import piranha from './images/piranha.png'
import sloth from './images/sloth.png'
import tiger from './images/tiger.png'
import toucan from './images/toucan.png'
import s from './memorygame.module.css'

const MemoryGame = () => {
  const [cards, setCards] = useState([])
  const [moves, setMoves] = useState(0)
  const [winCount, setWinCount] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [isWin, setIsWin] = useState(false)
  const [settings, setSettings] = useState({
    type: 'Animal',
    level: '1',
    no_of_questions: 8,
    curr_question: 0,
  })
  const minRef = useRef()

  const { selectedUser } = useSelector((state) => state.user)
  const { data: reports, isLoading: isLoadingReports, isError, error } = useGetGameReportsQuery(
    { userId: selectedUser?.id, gameTitle: 'Memory Game' },
    { skip: !selectedUser }
  )
  const [saveGameReport] = useSaveGameReportMutation()

  useEffect(() => {
    let items = [
      { name: 'bee', image: bee },
      { name: 'crocodile', image: crocodile },
      { name: 'macaw', image: macaw },
      { name: 'gorilla', image: gorilla },
      { name: 'tiger', image: tiger },
      { name: 'monkey', image: monkey },
      { name: 'chameleon', image: chameleon },
      { name: 'piranha', image: piranha },
      { name: 'anaconda', image: anaconda },
      { name: 'sloth', image: sloth },
      { name: 'cockatoo', image: cockatoo },
      { name: 'toucan', image: toucan },
    ]

    const pickRandomCardsAndShuffle = (size = 4) => {
      //temporary array
      let tempArray = [...items]

      //initializes cardValues array
      let cardValues = []

      //size should be double (4*4 matrix)/2 since pairs of objects would exist
      size = (size * size) / 2

      //Random object selection
      for (let i = 0; i < size; i++) {
        const randomIndex = Math.floor(Math.random() * tempArray.length)
        cardValues.push(tempArray[randomIndex])

        //once selected remove the object from temp array
        tempArray.splice(randomIndex, 1)
      }

      //Need double to make pairs
      cardValues = [...cardValues, ...cardValues]
      //simple shuffle
      cardValues.sort(() => Math.random() - 0.5)

      return cardValues
    }

    const shuffledCards = pickRandomCardsAndShuffle()
    setCards(shuffledCards)
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setSettings((old) => ({ ...old, [name]: value }))
  }

  const handleStart = () => {
    setMoves(0)
    setWinCount(0)
    setIsWin(false)

    setIsPlaying(true)
  }

  const handleStop = () => {
    setIsPlaying(false)

    const [minutes, seconds] = minRef.current.split(':')
    const durationInSeconds = parseInt(minutes) * 60 + parseInt(seconds)
    saveGameReport({
      user_id: selectedUser?.id,
      username: selectedUser.label,
      bet: winCount,
      time: seconds,
      category: 'Memory Game',
      score: moves,
      bet_array: [
        JSON.stringify({
          type: settings.type,
          level: settings.level,
          rate: moves < 12 ? 100 : Math.round((12 / moves) * 100),
          duration: durationInSeconds,
          avg: moves,
        }),
      ],
    })
  }

  //check if winCount === half of total cards
  useEffect(() => {
    if (cards.length > 0 && !isWin && winCount === Math.floor(cards.length / 2)) {
      setIsWin(true)
      handleStop()
    }
  }, [winCount, cards.length, isWin])

  let firstCard, secondCard
  let firstCardValue

  const handleClick = (e) => {
    if (e.target.className === 'image') return
    let card = e.target.offsetParent

    //Skip if card already matched or flipped
    if (card.classList.contains(s.flipped)) return

    //flip the cliked card
    card.classList.add(s.flipped)
    //if it is the firstcard (!firstCard since firstCard is initially false)
    if (!firstCard) {
      //so current card will become firstCard
      firstCard = card
      //current cards value becomes firstCardValue
      firstCardValue = card.getAttribute('data-card-value')
    } else {
      //increment moves since user selected second card
      setMoves((m) => m + 1)
      //secondCard and value
      secondCard = card
      let secondCardValue = card.getAttribute('data-card-value')
      if (firstCardValue === secondCardValue) {
        //set firstCard to false since next card would be first now
        firstCard = false
        //winCount increment as user found a correct match
        setWinCount((wc) => wc + 1)
      } else {
        //if the cards dont match
        //flip the cards back to normal
        let [tempFirst, tempSecond] = [firstCard, secondCard]
        firstCard = false
        secondCard = false
        setTimeout(() => {
          tempFirst.classList.remove(s.flipped)
          tempSecond.classList.remove(s.flipped)
        }, 500)
      }
    }
  }

  return (
    <Row>
      <Col lg={8} xxl={9} className='p-0'>
        <div
          className='d-flex align-items-center justify-content-between bg-white shadow-sm p-4 mb-3'
          style={{ height: '75px' }}
        >
          <div className='d-flex align-items-center gap-3'>
            <img src={memorygame} alt='memory game' height={48} width={48} />
            <h1 className={s.title}>Memory Game</h1>
          </div>
          <div className='d-flex align-items-center gap-4'>
            <p className='m-0'>User</p>
            <UserSelector />
            <div>
              <label htmlFor='type'>Type</label>
              <select
                id='type'
                name='type'
                value={settings.type}
                onChange={handleChange}
                required
                disabled={isPlaying}
                style={{ width: 'fit-content', padding: 0, height: '25px' }}
                className='ms-2 border border-2 rounded-pill'
              >
                <option value='Animals'>Animals</option>
              </select>
            </div>
            <div>
              <label htmlFor='level'>Level</label>
              <select
                id='level'
                name='level'
                value={settings.level}
                onChange={handleChange}
                required
                disabled={isPlaying}
                style={{ width: 'fit-content', padding: 0, height: '25px' }}
                className='ms-2 border border-2 rounded-pill'
              >
                {[1].map((lvl) => (
                  <option key={lvl} value={lvl}>
                    {lvl}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className='mx-auto' style={{ maxWidth: 'min-content' }}>
          <div className='d-flex align-items-center justify-content-between'>
            <div className='d-flex gap-2'>
              {isWin ? (
                <div className='px-3 py-2 rounded-pill text-white bg-success shadow-sm'>
                  <p className='m-0'>You won in {moves} moves</p>
                </div>
              ) : (
                isPlaying && (
                  <>
                    <div className='px-3 py-1 rounded-pill bg-white shadow-sm'>
                      <span className='text-secondary me-2'>Moves</span>
                      {moves}
                    </div>
                    <div className='px-3 py-1 rounded-pill bg-white shadow-sm'>
                      <span className='text-secondary me-2'>Time</span>
                      <Timer isPlaying={isPlaying} minRef={minRef} />
                    </div>
                  </>
                )
              )}
            </div>
            {isPlaying ? (
              <button className='py-2 px-4 border-0 rounded-3 bg-black text-white' onClick={() => setIsPlaying(false)}>
                Stop
              </button>
            ) : (
              <button className='py-2 px-4 border-0 rounded-3 bg-warning text-black' onClick={handleStart}>
                Start
              </button>
            )}
          </div>

          <div className={`dashboard-cards ${s.gameContainer} p-3`}>
            {cards.map((card, i) => (
              <div
                key={i}
                className={`${isPlaying ? 'pe-auto' : 'pe-none'} ${s.cardContainer}`}
                data-card-value={card.name}
                onClick={handleClick}
              >
                <div className={`${s.cardBefore}`}>?</div>
                <div className={`${s.cardAfter}`}>
                  <img src={card.image} className='image' alt={card.image} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Col>
      <Col
        lg={4}
        xxl={3}
        className='bg-white p-4'
        style={{ opacity: isPlaying ? 0 : 1, transition: 'opacity 0.2s ease' }}
      >
        <h6>Game Info</h6>
        <table className='table table-borderless table-sm mb-4' style={{ fontSize: 14 }}>
          <tbody>
            <tr>
              <td>Mode</td>
              <td className='fw-bold'>{settings.type}</td>
            </tr>
            <tr>
              <td>Level</td>
              <td className='fw-bold'>{settings.level}</td>
            </tr>
            <tr>
              <td>Number of Pairs</td>
              <td className='fw-bold'>{settings.no_of_questions}</td>
            </tr>
          </tbody>
        </table>

        <h6>Reports</h6>
        {isLoadingReports ? (
          'Loading'
        ) : isError ? (
          <p>{error.message}</p>
        ) : reports?.length === 0 ? (
          'No reports yet'
        ) : (
          <div className='mb-3' style={{ overflowY: 'auto', maxHeight: '100px' }}>
            <table className='table table-sm table-hover' style={{ fontSize: '10px' }}>
              <thead className='bg-white table-group-divider align-middle position-sticky top-0'>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Level</th>
                  <th>Rate</th>
                  <th>Moves</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody className='table-group-divider align-middle'>
                {reports.map((report, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{report.type}</td>
                    <td>{report.level}</td>
                    <td>{report.rate}%</td>
                    <td>{report.avg}</td>
                    <td>{report.duration}s</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <h6>How to play</h6>
        <ol style={{ fontSize: 14 }}>
          <li>To start the game press start button.</li>
          <li>Click to the flip cards and find the matching pairs</li>
          <li>Game ends once you've found all matching pairs</li>
        </ol>
      </Col>
    </Row>
  )
}

export default MemoryGame

export const Timer = ({ isPlaying, minRef }) => {
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(0)

  let interval = useRef()

  //For timer
  useEffect(() => {
    minRef.current = `${minutes}:${seconds}`
    if (seconds >= 60) {
      setMinutes((m) => m + 1)
      setSeconds(0)
    }
  }, [seconds])

  useEffect(() => {
    if (isPlaying) {
      interval.current = setInterval(() => setSeconds((s) => s + 1), 1000)
    } else {
      clearInterval(interval.current)
      setSeconds(0)
      setMinutes(0)
    }

    return () => clearInterval(interval.current)
  }, [isPlaying])

  return (
    <>
      {minutes <= 9 ? `0${minutes}` : minutes} : {seconds <= 9 ? `0${seconds}` : seconds}
    </>
  )
}
